import { Dialog } from '@/shared/ui/dialog'
import { VLayout } from '@/shared/ui/layouts/flex'
import { Typography } from '@/shared/ui/typography'

import { useTranslation } from 'react-i18next'

import { useMaintenanceModalController } from './useMaintenanceModalController'

/**
 * Blocking, non-dismissable modal shown whenever the backend is unreachable (HTTP 503).
 *
 * Mounted once at the application root (see `App.tsx`) so it survives route changes. It
 * deliberately does NOT use `Dialog.Header`: the DS header always renders a close (X) button with
 * no opt-out prop, which would be visually misleading during a real outage. The title is rendered
 * as plain `Typography` inside `Dialog.Body` instead, so the dialog has no close affordance at
 * all (no close button, no `Dialog.Actions`/`Dialog.CancelAction`, no ESC, no backdrop click). It
 * closes itself automatically once the recovery polling succeeds — see
 * `useMaintenanceModalController`.
 */
export const MaintenanceModal = () => {
  const { t } = useTranslation()
  const { isOpen } = useMaintenanceModalController()

  return (
    <Dialog isOpen={isOpen} size="md">
      <Dialog.Body>
        <VLayout gap="2">
          <Typography type="heading" variant="h4-bold">
            {t('maintenance.title')}
          </Typography>
          <Typography type="paragraph" variant="sm">
            {t('maintenance.message')}
          </Typography>
        </VLayout>
      </Dialog.Body>
    </Dialog>
  )
}
